module.exports = __webpack_public_path__ + "static/media/cloud-uploading.d96c0e67.svg";